export function getFilterSectionKeys() {
  return [
    'types',
    'status',
    'validation',
    'users',
    'location',
    'routines',
    'date',
  ]
}

export function buildSituationTypeOption(
  situation = {},
  translate = key => key
) {
  const translationKey = `situation_types.${situation?.name}`
  const translatedText = translate(translationKey)

  return {
    ...situation,
    text: translatedText === translationKey ? situation?.name : translatedText,
    value: situation?.name,
  }
}

export function buildCategoryOption(category = {}, translate = key => key) {
  const translationKey = `categories.${category?.name}`
  const translatedText = translate(translationKey)

  return {
    ...category,
    text: translatedText === translationKey ? category?.name : translatedText,
    value: category?.name,
  }
}

export function hasRoutineFilterSupport(typeOptions = []) {
  return typeOptions.some(option => {
    return option?.id === 'routine' || option?.id === 'finding'
  })
}
